module Meevo.Plugins.Client {
    class EmailDuplicateWarningModal {
        public clients: Model.Client[];

        static $inject = ['$mdDialog'];

        constructor(protected $mdDialog: angular.material.IDialogService) {
        }

        /**
         * Close modal window
         * */
        public cancel(): void {
            this.$mdDialog.cancel();
        }

        public yes(): void {
            this.$mdDialog.hide(this.clients[0]);
        }
    }

    angular.module('meevo.plugins.client')
        .controller('meevo.plugins.client.EmailDuplicateWarningModal', EmailDuplicateWarningModal);
}
